import * as React from "react"
import Modal from 'react-modal';

export default class ConfirmStatusChange extends React.PureComponent {
    state = {
        open: false,
        callback: null
    }

    show = callback => event => {
        event.preventDefault()

        event = {
            ...event,
            target: { ...event.target, value: event.target.value }
        }

        this.setState({
            open: true,
            callback: () => callback(event)
        })
    }

    hide = () => this.setState({ open: false, callback: null })

    confirm = () => {
        this.state.callback()
        this.hide()
    }

    render() {
        return (
            <React.Fragment>
                {this.props.children(this.show)}

                <Modal
                    style={{
                        content: {
                            top: '50%',
                            left: '50%',
                            right: 'auto',
                            bottom: 'auto',
                            marginRight: '-50%',
                            transform: 'translate(-50%, -50%)'
                        }
                    }}
                    isOpen={this.state.open}
                    ariaHideApp={false}
                    overlayClassName='cameo'
                    shouldCloseOnOverlayClick={false}
                >
                    <div className="modal-body" style={{ maxWidth: '500px', minWidth: '250px' }}>
                        <h3>{this.props.title}</h3>
                        <p>{this.props.description}</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-primary" onClick={this.hide}>Cancel</button>
                        <button type="button" className="btn btn-outline-secondary" onClick={this.confirm}>OK</button>
                    </div>
                </Modal>
            </React.Fragment>
        )
    }
}
